import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import {Link} from "react-router-dom";
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const CategorySection = () => {
  return (
    <div className='banners explore_new'>
        <Container>
            <Row md={3} xs={1}>
                <Col className='p-0'>
                    <div className="banner-block banner-1 aos-init aos-animate" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
                        <div className="banner-box bimg_box">
                            <LazyLoadImage src={`${ImageUrl}theme/tokyo/engagement_ring.jpg`} alt="banner-1" className="img-responsive" />
                                            
                            <div className="s-desc">
                                <h3>Engagement Rings</h3>
                                <div className="bannerb_button text-center">
                                    <Link to="/ringsettings" className="main_button text-white">Shop Now</Link>
                                </div>
                            </div>			 
                        </div>
                    </div>
                </Col>
                <Col className='p-0'>
                    <div className="banner-block banner-1 aos-init aos-animate" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="2000">
                        <div className="banner-box bimg_box">
                            <LazyLoadImage src={`${ImageUrl}theme/tokyo/diamond.jpg`} alt="banner-1" className="img-responsive" />
                                            
                            <div className="s-desc">
                                <h3>Diamonds</h3>
                                <div className="bannerb_button">
                                    <Link to="/diamonds" className="main_button text-white">Shop Now</Link>
                                </div>
                            </div>          
                        </div>
                    </div>
                </Col>
                <Col className='p-0'>
                    <div className="banner-block banner-1 aos-init aos-animate" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="2000">
                        <div className="banner-box bimg_box">
                            <LazyLoadImage src={`${ImageUrl}theme/tokyo/wedding_ring.jpg`} alt="banner-1" className="img-responsive" />
                                            
                            <div className="s-desc">
                                <h3>Wedding Rings</h3>
                                <div className="bannerb_button">
                                    <Link to="/jewelry/wedding-rings" className="main_button text-white">Shop Now</Link>
                                </div>
                            </div>
                                            
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

export default CategorySection